{
    "_comment": [
        "SINGLE SOURCE OF TRUTH for channel classification data.",
        "",
        "This file is read at runtime by src/Classification/ChannelRules.php and inlined at",
        "build time by assets/js/src/rules.js. Both runtimes therefore classify against the",
        "same lists. The two implementations of the ALGORITHM are kept in step by",
        "tests/fixtures/classifier-cases.json, which both test suites execute -- see the",
        "cross-runtime job in .github/workflows/ci.yml.",
        "",
        "Editing this file changes both runtimes. Adding a click ID or a source token here",
        "needs a deploy; the cc_attr_channel_rules PHP filter and window.ccAttrConfig.rules",
        "override exist so marketing can add one without waiting for a deploy.",
        "",
        "Host lists hold registrable domains, not full hostnames. Matching is: exact host,",
        "then domain suffix, then a brand-label match that tolerates ccTLDs (google.co.uk)",
        "without ever inferring the registrable domain by counting labels.",
        "",
        "Four rules for non-paid referrals, added in 1.1:",
        "  A referrerHosts value of \"referral\" declares a plain referral, NOT search. Used",
        "    for Google properties that are not Google Search (Docs, Drive, Sites...), which",
        "    would otherwise brand-match `google` and be credited to organic search.",
        "  emailHostPrefixes: a referring host whose FIRST label is one of these is webmail",
        "    (mail.aol.com, webmail.company.com). Checked after an exact host match and",
        "    before suffix and brand matching, so mail.aol.com is not credited to search.",
        "  appReferrers: Android package names, consulted ONLY for an android-app://",
        "    referrer -- what the Gmail, Outlook and LinkedIn apps send when opening a link.",
        "  excludedReferrers: hosts that are never evidence of how a visitor was acquired:",
        "    sign-in and payment providers a visitor leaves for and returns from. A page view",
        "    they refer is not a touch. Matched on exact host or domain suffix."
    ],

    "campaignParams": {
        "source": [ "utm_source", "mtm_source", "pk_source" ],
        "medium": [ "utm_medium", "mtm_medium", "pk_medium" ],
        "campaign": [ "utm_campaign", "mtm_campaign", "mtm_cpn", "pk_campaign", "pk_cpn" ],
        "content": [ "utm_content", "mtm_content", "pk_content" ],
        "term": [ "utm_term", "mtm_kwd", "pk_kwd" ]
    },

    "clickIds": [
        { "param": "gclid",     "platform": "google_ads",    "surface": "search",    "paid": true,  "source": "google",    "medium": "cpc" },
        { "param": "gbraid",    "platform": "google_ads",    "surface": "search",    "paid": true,  "source": "google",    "medium": "cpc" },
        { "param": "wbraid",    "platform": "google_ads",    "surface": "search",    "paid": true,  "source": "google",    "medium": "cpc" },
        { "param": "dclid",     "platform": "google_display","surface": "display",   "paid": true,  "source": "google",    "medium": "display" },
        { "param": "msclkid",   "platform": "microsoft_ads", "surface": "search",    "paid": true,  "source": "bing",      "medium": "cpc" },
        { "param": "fbclid",    "platform": "meta",          "surface": "social",    "paid": false, "source": "facebook",  "medium": "social" },
        { "param": "ttclid",    "platform": "tiktok_ads",    "surface": "social",    "paid": true,  "source": "tiktok",    "medium": "cpc" },
        { "param": "li_fat_id", "platform": "linkedin_ads",  "surface": "social",    "paid": true,  "source": "linkedin",  "medium": "cpc" },
        { "param": "twclid",    "platform": "x_ads",         "surface": "social",    "paid": true,  "source": "twitter",   "medium": "cpc" },
        { "param": "rdt_cid",   "platform": "reddit_ads",    "surface": "social",    "paid": true,  "source": "reddit",    "medium": "cpc" },
        { "param": "irclickid", "platform": "impact",        "surface": "affiliate", "paid": true,  "source": "impact",    "medium": "affiliate" }
    ],

    "mediums": {
        "paid": [
            "cpc", "ppc", "cpm", "cpv", "cpa", "cpp", "cpe", "cpi",
            "paid", "paidsearch", "paid-search", "paid_search",
            "paidsocial", "paid-social", "paid_social",
            "sem", "ppcad", "adwords", "google_ads", "googleads",
            "retargeting", "remarketing", "sponsored", "paidvideo", "paid-video"
        ],
        "display": [
            "display", "banner", "banners", "programmatic", "native",
            "richmedia", "rich-media", "interstitial", "gdn", "dv360"
        ],
        "organicSearch": [ "organic", "natural", "seo", "organic-search", "organic_search" ],
        "organicSocial": [
            "social", "social-network", "social_network", "socialmedia",
            "social-media", "social_media", "sm", "organic-social", "organic_social",
            "post", "community"
        ],
        "email": [ "email", "e-mail", "e_mail", "mail", "newsletter", "edm", "drip", "nurture" ],
        "affiliate": [ "affiliate", "affiliates", "partner", "partners", "cj", "impact-radius" ],
        "referral": [ "referral", "refer", "referrer", "link", "links" ]
    },

    "sourceTokens": {
        "google": "search",
        "bing": "search",
        "yahoo": "search",
        "duckduckgo": "search",
        "ddg": "search",
        "baidu": "search",
        "yandex": "search",
        "ecosia": "search",
        "brave": "search",
        "startpage": "search",
        "qwant": "search",
        "naver": "search",
        "daum": "search",
        "seznam": "search",
        "sogou": "search",
        "ask": "search",
        "aol": "search",
        "mojeek": "search",

        "chatgpt": "ai",
        "openai": "ai",
        "perplexity": "ai",
        "claude": "ai",
        "anthropic": "ai",
        "copilot": "ai",
        "gemini": "ai",
        "bard": "ai",

        "facebook": "social",
        "fb": "social",
        "instagram": "social",
        "ig": "social",
        "linkedin": "social",
        "twitter": "social",
        "x": "social",
        "tiktok": "social",
        "pinterest": "social",
        "reddit": "social",
        "snapchat": "social",
        "youtube": "social",
        "whatsapp": "social",
        "telegram": "social",
        "threads": "social",
        "mastodon": "social",
        "discord": "social",
        "tumblr": "social",
        "nextdoor": "social",
        "xing": "social",
        "vk": "social",
        "weibo": "social",
        "quora": "social",

        "doubleclick": "display",
        "criteo": "display",
        "taboola": "display",
        "outbrain": "display",
        "adroll": "display",
        "tradedesk": "display",
        "thetradedesk": "display",
        "dv360": "display",
        "appnexus": "display",
        "xandr": "display",
        "mediamath": "display",
        "revcontent": "display",
        "zemanta": "display",

        "newsletter": "email",
        "mailchimp": "email",
        "klaviyo": "email",
        "sendgrid": "email",
        "campaignmonitor": "email",
        "constantcontact": "email",
        "marketo": "email",
        "pardot": "email",
        "exacttarget": "email",
        "braze": "email",
        "iterable": "email",
        "activecampaign": "email",
        "customerio": "email",
        "hubspot-email": "email",

        "impact": "affiliate",
        "impactradius": "affiliate",
        "shareasale": "affiliate",
        "awin": "affiliate",
        "rakuten": "affiliate",
        "partnerstack": "affiliate",
        "refersion": "affiliate",
        "commissionjunction": "affiliate"
    },

    "referrerHosts": {
        "google.com": "search",
        "bing.com": "search",
        "yahoo.com": "search",
        "duckduckgo.com": "search",
        "baidu.com": "search",
        "yandex.com": "search",
        "yandex.ru": "search",
        "ecosia.org": "search",
        "search.brave.com": "search",
        "startpage.com": "search",
        "qwant.com": "search",
        "naver.com": "search",
        "daum.net": "search",
        "seznam.cz": "search",
        "sogou.com": "search",
        "ask.com": "search",
        "aol.com": "search",
        "mojeek.com": "search",

        "chatgpt.com": "ai",
        "chat.openai.com": "ai",
        "openai.com": "ai",
        "perplexity.ai": "ai",
        "claude.ai": "ai",
        "copilot.microsoft.com": "ai",
        "gemini.google.com": "ai",
        "bard.google.com": "ai",
        "you.com": "ai",
        "poe.com": "ai",

        "facebook.com": "social",
        "fb.com": "social",
        "fb.me": "social",
        "instagram.com": "social",
        "linkedin.com": "social",
        "lnkd.in": "social",
        "twitter.com": "social",
        "x.com": "social",
        "t.co": "social",
        "tiktok.com": "social",
        "pinterest.com": "social",
        "reddit.com": "social",
        "snapchat.com": "social",
        "youtube.com": "social",
        "youtu.be": "social",
        "whatsapp.com": "social",
        "telegram.org": "social",
        "t.me": "social",
        "threads.net": "social",
        "threads.com": "social",
        "discord.com": "social",
        "tumblr.com": "social",
        "nextdoor.com": "social",
        "xing.com": "social",
        "vk.com": "social",
        "weibo.com": "social",
        "quora.com": "social",

        "mail.google.com": "email",
        "outlook.live.com": "email",
        "outlook.office.com": "email",
        "outlook.office365.com": "email",
        "mail.yahoo.com": "email",
        "mail.proton.me": "email",
        "mail.zoho.com": "email",
        "campaign-archive.com": "email",
        "mailchi.mp": "email",

        "docs.google.com": "referral",
        "drive.google.com": "referral",
        "sites.google.com": "referral",
        "groups.google.com": "referral",
        "calendar.google.com": "referral",
        "meet.google.com": "referral",
        "chat.google.com": "referral",
        "classroom.google.com": "referral",

        "doubleclick.net": "display",
        "googlesyndication.com": "display",
        "criteo.com": "display",
        "taboola.com": "display",
        "outbrain.com": "display",

        "impact.com": "affiliate",
        "shareasale.com": "affiliate",
        "awin.com": "affiliate",
        "linksynergy.com": "affiliate"
    },

    "brandHostTokens": {
        "google": "search",
        "bing": "search",
        "yahoo": "search",
        "duckduckgo": "search",
        "yandex": "search",
        "ecosia": "search",
        "baidu": "search",
        "naver": "search",
        "seznam": "search",
        "facebook": "social",
        "instagram": "social",
        "linkedin": "social",
        "twitter": "social",
        "tiktok": "social",
        "pinterest": "social",
        "reddit": "social",
        "youtube": "social"
    },

    "emailHostPrefixes": [ "mail", "webmail" ],

    "appReferrers": {
        "com.google.android.gm": "email",
        "com.microsoft.office.outlook": "email",
        "com.yahoo.mobile.client.android.mail": "email",
        "ch.protonmail.android": "email",
        "com.samsung.android.email.provider": "email",

        "com.google.android.googlequicksearchbox": "search",

        "com.linkedin.android": "social",
        "com.facebook.katana": "social",
        "com.facebook.orca": "social",
        "com.instagram.android": "social",
        "com.twitter.android": "social",
        "com.reddit.frontpage": "social",
        "com.pinterest": "social",
        "com.zhiliaoapp.musically": "social",
        "com.whatsapp": "social",
        "org.telegram.messenger": "social",
        "com.google.android.youtube": "social"
    },

    "excludedReferrers": [
        "accounts.google.com",
        "login.microsoftonline.com",
        "login.live.com",
        "appleid.apple.com",
        "paypal.com",
        "checkout.stripe.com",
        "hooks.stripe.com"
    ]
}
